/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SponsorRouteImport } from './routes/sponsor'
import { Route as PlayerRouteImport } from './routes/player'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ConfiguratorRouteImport } from './routes/configurator'
import { Route as BuilderRouteImport } from './routes/builder'
import { Route as AdminRouteImport } from './routes/admin'

const VerifyEmailLazyRouteImport = createFileRoute('/verify-email')()
const TermsLazyRouteImport = createFileRoute('/terms')()
const ResetPasswordLazyRouteImport = createFileRoute('/reset-password')()
const RegisterLazyRouteImport = createFileRoute('/register')()
const ProfileLazyRouteImport = createFileRoute('/profile')()
const LoginLazyRouteImport = createFileRoute('/login')()
const LeaderboardLazyRouteImport = createFileRoute('/leaderboard')()
const HelpLazyRouteImport = createFileRoute('/help')()
const CommunityLazyRouteImport = createFileRoute('/community')()
const ChangelogLazyRouteImport = createFileRoute('/changelog')()
const SplatLazyRouteImport = createFileRoute('/$')()
const IndexLazyRouteImport = createFileRoute('/')()
const DashboardIndexLazyRouteImport = createFileRoute('/dashboard/')()
const TournamentIdLazyRouteImport = createFileRoute('/tournament/$id')()
const ProfileUsernameLazyRouteImport = createFileRoute('/profile/$username')()
const DocsApiLazyRouteImport = createFileRoute('/docs/api')()
const DashboardSponsorsLazyRouteImport = createFileRoute(
  '/dashboard/sponsors',
)()
const DashboardSettingsLazyRouteImport = createFileRoute(
  '/dashboard/settings',
)()
const DashboardReportLazyRouteImport = createFileRoute('/dashboard/report')()
const DashboardReferralLazyRouteImport = createFileRoute(
  '/dashboard/referral',
)()
const DashboardNotificationsLazyRouteImport = createFileRoute(
  '/dashboard/notifications',
)()
const DashboardMessagesLazyRouteImport = createFileRoute(
  '/dashboard/messages',
)()
const DashboardMediaLazyRouteImport = createFileRoute('/dashboard/media')()
const DashboardInfluencersLazyRouteImport = createFileRoute(
  '/dashboard/influencers',
)()
const DashboardEmptyStatesLazyRouteImport = createFileRoute(
  '/dashboard/empty-states',
)()
const DashboardBrandingLazyRouteImport = createFileRoute(
  '/dashboard/branding',
)()
const DashboardBillingLazyRouteImport = createFileRoute('/dashboard/billing')()
const DashboardArchiveLazyRouteImport = createFileRoute('/dashboard/archive')()
const DashboardAnnouncementsLazyRouteImport = createFileRoute(
  '/dashboard/announcements',
)()
const DashboardAnalyticsLazyRouteImport = createFileRoute(
  '/dashboard/analytics',
)()
const DashboardAccountLazyRouteImport = createFileRoute('/dashboard/account')()
const AdminUsersLazyRouteImport = createFileRoute('/admin/users')()
const AdminRolesLazyRouteImport = createFileRoute('/admin/roles')()
const AdminDisputesLazyRouteImport = createFileRoute('/admin/disputes')()
const AdminAuditLogLazyRouteImport = createFileRoute('/admin/audit-log')()
const DashboardTournamentsTemplatesLazyRouteImport = createFileRoute(
  '/dashboard/tournaments/templates',
)()
const DashboardTournamentsSeedingLazyRouteImport = createFileRoute(
  '/dashboard/tournaments/seeding',
)()
const DashboardTournamentsRulesLazyRouteImport = createFileRoute(
  '/dashboard/tournaments/rules',
)()
const DashboardTournamentsLiveLazyRouteImport = createFileRoute(
  '/dashboard/tournaments/live',
)()
const DashboardSettingsNotificationsLazyRouteImport = createFileRoute(
  '/dashboard/settings/notifications',
)()
const DashboardSettingsIntegrationsLazyRouteImport = createFileRoute(
  '/dashboard/settings/integrations',
)()
const DashboardSettingsDataLazyRouteImport = createFileRoute(
  '/dashboard/settings/data',
)()
const DashboardBroadcastPreflightLazyRouteImport = createFileRoute(
  '/dashboard/broadcast/preflight',
)()
const DashboardActivationsEditLazyRouteImport = createFileRoute(
  '/dashboard/activations/edit',
)()

const VerifyEmailLazyRoute = VerifyEmailLazyRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/verify-email.lazy').then((d) => d.Route))
const TermsLazyRoute = TermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))
const ResetPasswordLazyRoute = ResetPasswordLazyRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reset-password.lazy').then((d) => d.Route),
)
const RegisterLazyRoute = RegisterLazyRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/register.lazy').then((d) => d.Route))
const ProfileLazyRoute = ProfileLazyRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const LeaderboardLazyRoute = LeaderboardLazyRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/leaderboard.lazy').then((d) => d.Route))
const HelpLazyRoute = HelpLazyRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/help.lazy').then((d) => d.Route))
const CommunityLazyRoute = CommunityLazyRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/community.lazy').then((d) => d.Route))
const ChangelogLazyRoute = ChangelogLazyRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/changelog.lazy').then((d) => d.Route))
const SplatLazyRoute = SplatLazyRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/$.lazy').then((d) => d.Route))
const SponsorRoute = SponsorRouteImport.update({
  id: '/sponsor',
  path: '/sponsor',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/sponsor.lazy').then((d) => d.Route))
const PlayerRoute = PlayerRouteImport.update({
  id: '/player',
  path: '/player',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/player.lazy').then((d) => d.Route))
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/onboarding.lazy').then((d) => d.Route))
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/notifications.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguratorRoute = ConfiguratorRouteImport.update({
  id: '/configurator',
  path: '/configurator',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/configurator.lazy').then((d) => d.Route))
const BuilderRoute = BuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/builder.lazy').then((d) => d.Route))
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const DashboardIndexLazyRoute = DashboardIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const TournamentIdLazyRoute = TournamentIdLazyRouteImport.update({
  id: '/tournament/$id',
  path: '/tournament/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/tournament.$id.lazy').then((d) => d.Route),
)
const ProfileUsernameLazyRoute = ProfileUsernameLazyRouteImport.update({
  id: '/$username',
  path: '/$username',
  getParentRoute: () => ProfileLazyRoute,
} as any).lazy(() =>
  import('./routes/profile.$username.lazy').then((d) => d.Route),
)
const DocsApiLazyRoute = DocsApiLazyRouteImport.update({
  id: '/docs/api',
  path: '/docs/api',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/docs/api.lazy').then((d) => d.Route))
const DashboardSponsorsLazyRoute = DashboardSponsorsLazyRouteImport.update({
  id: '/sponsors',
  path: '/sponsors',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/sponsors.lazy').then((d) => d.Route),
)
const DashboardSettingsLazyRoute = DashboardSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/settings.lazy').then((d) => d.Route),
)
const DashboardReportLazyRoute = DashboardReportLazyRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/report.lazy').then((d) => d.Route),
)
const DashboardReferralLazyRoute = DashboardReferralLazyRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/referral.lazy').then((d) => d.Route),
)
const DashboardNotificationsLazyRoute =
  DashboardNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/notifications.lazy').then((d) => d.Route),
  )
const DashboardMessagesLazyRoute = DashboardMessagesLazyRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/messages.lazy').then((d) => d.Route),
)
const DashboardMediaLazyRoute = DashboardMediaLazyRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/media.lazy').then((d) => d.Route),
)
const DashboardInfluencersLazyRoute =
  DashboardInfluencersLazyRouteImport.update({
    id: '/influencers',
    path: '/influencers',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/influencers.lazy').then((d) => d.Route),
  )
const DashboardEmptyStatesLazyRoute =
  DashboardEmptyStatesLazyRouteImport.update({
    id: '/empty-states',
    path: '/empty-states',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/empty-states.lazy').then((d) => d.Route),
  )
const DashboardBrandingLazyRoute = DashboardBrandingLazyRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/branding.lazy').then((d) => d.Route),
)
const DashboardBillingLazyRoute = DashboardBillingLazyRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/billing.lazy').then((d) => d.Route),
)
const DashboardArchiveLazyRoute = DashboardArchiveLazyRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/archive.lazy').then((d) => d.Route),
)
const DashboardAnnouncementsLazyRoute =
  DashboardAnnouncementsLazyRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/announcements.lazy').then((d) => d.Route),
  )
const DashboardAnalyticsLazyRoute = DashboardAnalyticsLazyRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/analytics.lazy').then((d) => d.Route),
)
const DashboardAccountLazyRoute = DashboardAccountLazyRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/account.lazy').then((d) => d.Route),
)
const AdminUsersLazyRoute = AdminUsersLazyRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any).lazy(() => import('./routes/admin/users.lazy').then((d) => d.Route))
const AdminRolesLazyRoute = AdminRolesLazyRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRoute,
} as any).lazy(() => import('./routes/admin/roles.lazy').then((d) => d.Route))
const AdminDisputesLazyRoute = AdminDisputesLazyRouteImport.update({
  id: '/disputes',
  path: '/disputes',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/disputes.lazy').then((d) => d.Route),
)
const AdminAuditLogLazyRoute = AdminAuditLogLazyRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/audit-log.lazy').then((d) => d.Route),
)
const DashboardTournamentsTemplatesLazyRoute =
  DashboardTournamentsTemplatesLazyRouteImport.update({
    id: '/tournaments/templates',
    path: '/tournaments/templates',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/tournaments/templates.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardTournamentsSeedingLazyRoute =
  DashboardTournamentsSeedingLazyRouteImport.update({
    id: '/tournaments/seeding',
    path: '/tournaments/seeding',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/tournaments/seeding.lazy').then((d) => d.Route),
  )
const DashboardTournamentsRulesLazyRoute =
  DashboardTournamentsRulesLazyRouteImport.update({
    id: '/tournaments/rules',
    path: '/tournaments/rules',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/tournaments/rules.lazy').then((d) => d.Route),
  )
const DashboardTournamentsLiveLazyRoute =
  DashboardTournamentsLiveLazyRouteImport.update({
    id: '/tournaments/live',
    path: '/tournaments/live',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/tournaments/live.lazy').then((d) => d.Route),
  )
const DashboardSettingsNotificationsLazyRoute =
  DashboardSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardSettingsLazyRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsIntegrationsLazyRoute =
  DashboardSettingsIntegrationsLazyRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => DashboardSettingsLazyRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/settings/integrations.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsDataLazyRoute =
  DashboardSettingsDataLazyRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => DashboardSettingsLazyRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/settings/data.lazy').then((d) => d.Route),
  )
const DashboardBroadcastPreflightLazyRoute =
  DashboardBroadcastPreflightLazyRouteImport.update({
    id: '/broadcast/preflight',
    path: '/broadcast/preflight',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/broadcast/preflight.lazy').then((d) => d.Route),
  )
const DashboardActivationsEditLazyRoute =
  DashboardActivationsEditLazyRouteImport.update({
    id: '/activations/edit',
    path: '/activations/edit',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/activations/edit.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRouteWithChildren
  '/builder': typeof BuilderRoute
  '/configurator': typeof ConfiguratorRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/player': typeof PlayerRoute
  '/sponsor': typeof SponsorRoute
  '/$': typeof SplatLazyRoute
  '/changelog': typeof ChangelogLazyRoute
  '/community': typeof CommunityLazyRoute
  '/help': typeof HelpLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
  '/login': typeof LoginLazyRoute
  '/profile': typeof ProfileLazyRouteWithChildren
  '/register': typeof RegisterLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/terms': typeof TermsLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/admin/audit-log': typeof AdminAuditLogLazyRoute
  '/admin/disputes': typeof AdminDisputesLazyRoute
  '/admin/roles': typeof AdminRolesLazyRoute
  '/admin/users': typeof AdminUsersLazyRoute
  '/dashboard/account': typeof DashboardAccountLazyRoute
  '/dashboard/analytics': typeof DashboardAnalyticsLazyRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsLazyRoute
  '/dashboard/archive': typeof DashboardArchiveLazyRoute
  '/dashboard/billing': typeof DashboardBillingLazyRoute
  '/dashboard/branding': typeof DashboardBrandingLazyRoute
  '/dashboard/empty-states': typeof DashboardEmptyStatesLazyRoute
  '/dashboard/influencers': typeof DashboardInfluencersLazyRoute
  '/dashboard/media': typeof DashboardMediaLazyRoute
  '/dashboard/messages': typeof DashboardMessagesLazyRoute
  '/dashboard/notifications': typeof DashboardNotificationsLazyRoute
  '/dashboard/referral': typeof DashboardReferralLazyRoute
  '/dashboard/report': typeof DashboardReportLazyRoute
  '/dashboard/settings': typeof DashboardSettingsLazyRouteWithChildren
  '/dashboard/sponsors': typeof DashboardSponsorsLazyRoute
  '/docs/api': typeof DocsApiLazyRoute
  '/profile/$username': typeof ProfileUsernameLazyRoute
  '/tournament/$id': typeof TournamentIdLazyRoute
  '/dashboard/': typeof DashboardIndexLazyRoute
  '/dashboard/activations/edit': typeof DashboardActivationsEditLazyRoute
  '/dashboard/broadcast/preflight': typeof DashboardBroadcastPreflightLazyRoute
  '/dashboard/settings/data': typeof DashboardSettingsDataLazyRoute
  '/dashboard/settings/integrations': typeof DashboardSettingsIntegrationsLazyRoute
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsLazyRoute
  '/dashboard/tournaments/live': typeof DashboardTournamentsLiveLazyRoute
  '/dashboard/tournaments/rules': typeof DashboardTournamentsRulesLazyRoute
  '/dashboard/tournaments/seeding': typeof DashboardTournamentsSeedingLazyRoute
  '/dashboard/tournaments/templates': typeof DashboardTournamentsTemplatesLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRouteWithChildren
  '/builder': typeof BuilderRoute
  '/configurator': typeof ConfiguratorRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/player': typeof PlayerRoute
  '/sponsor': typeof SponsorRoute
  '/$': typeof SplatLazyRoute
  '/changelog': typeof ChangelogLazyRoute
  '/community': typeof CommunityLazyRoute
  '/help': typeof HelpLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
  '/login': typeof LoginLazyRoute
  '/profile': typeof ProfileLazyRouteWithChildren
  '/register': typeof RegisterLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/terms': typeof TermsLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/admin/audit-log': typeof AdminAuditLogLazyRoute
  '/admin/disputes': typeof AdminDisputesLazyRoute
  '/admin/roles': typeof AdminRolesLazyRoute
  '/admin/users': typeof AdminUsersLazyRoute
  '/dashboard/account': typeof DashboardAccountLazyRoute
  '/dashboard/analytics': typeof DashboardAnalyticsLazyRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsLazyRoute
  '/dashboard/archive': typeof DashboardArchiveLazyRoute
  '/dashboard/billing': typeof DashboardBillingLazyRoute
  '/dashboard/branding': typeof DashboardBrandingLazyRoute
  '/dashboard/empty-states': typeof DashboardEmptyStatesLazyRoute
  '/dashboard/influencers': typeof DashboardInfluencersLazyRoute
  '/dashboard/media': typeof DashboardMediaLazyRoute
  '/dashboard/messages': typeof DashboardMessagesLazyRoute
  '/dashboard/notifications': typeof DashboardNotificationsLazyRoute
  '/dashboard/referral': typeof DashboardReferralLazyRoute
  '/dashboard/report': typeof DashboardReportLazyRoute
  '/dashboard/settings': typeof DashboardSettingsLazyRouteWithChildren
  '/dashboard/sponsors': typeof DashboardSponsorsLazyRoute
  '/docs/api': typeof DocsApiLazyRoute
  '/profile/$username': typeof ProfileUsernameLazyRoute
  '/tournament/$id': typeof TournamentIdLazyRoute
  '/dashboard': typeof DashboardIndexLazyRoute
  '/dashboard/activations/edit': typeof DashboardActivationsEditLazyRoute
  '/dashboard/broadcast/preflight': typeof DashboardBroadcastPreflightLazyRoute
  '/dashboard/settings/data': typeof DashboardSettingsDataLazyRoute
  '/dashboard/settings/integrations': typeof DashboardSettingsIntegrationsLazyRoute
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsLazyRoute
  '/dashboard/tournaments/live': typeof DashboardTournamentsLiveLazyRoute
  '/dashboard/tournaments/rules': typeof DashboardTournamentsRulesLazyRoute
  '/dashboard/tournaments/seeding': typeof DashboardTournamentsSeedingLazyRoute
  '/dashboard/tournaments/templates': typeof DashboardTournamentsTemplatesLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRouteWithChildren
  '/builder': typeof BuilderRoute
  '/configurator': typeof ConfiguratorRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/player': typeof PlayerRoute
  '/sponsor': typeof SponsorRoute
  '/$': typeof SplatLazyRoute
  '/changelog': typeof ChangelogLazyRoute
  '/community': typeof CommunityLazyRoute
  '/help': typeof HelpLazyRoute
  '/leaderboard': typeof LeaderboardLazyRoute
  '/login': typeof LoginLazyRoute
  '/profile': typeof ProfileLazyRouteWithChildren
  '/register': typeof RegisterLazyRoute
  '/reset-password': typeof ResetPasswordLazyRoute
  '/terms': typeof TermsLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/admin/audit-log': typeof AdminAuditLogLazyRoute
  '/admin/disputes': typeof AdminDisputesLazyRoute
  '/admin/roles': typeof AdminRolesLazyRoute
  '/admin/users': typeof AdminUsersLazyRoute
  '/dashboard/account': typeof DashboardAccountLazyRoute
  '/dashboard/analytics': typeof DashboardAnalyticsLazyRoute
  '/dashboard/announcements': typeof DashboardAnnouncementsLazyRoute
  '/dashboard/archive': typeof DashboardArchiveLazyRoute
  '/dashboard/billing': typeof DashboardBillingLazyRoute
  '/dashboard/branding': typeof DashboardBrandingLazyRoute
  '/dashboard/empty-states': typeof DashboardEmptyStatesLazyRoute
  '/dashboard/influencers': typeof DashboardInfluencersLazyRoute
  '/dashboard/media': typeof DashboardMediaLazyRoute
  '/dashboard/messages': typeof DashboardMessagesLazyRoute
  '/dashboard/notifications': typeof DashboardNotificationsLazyRoute
  '/dashboard/referral': typeof DashboardReferralLazyRoute
  '/dashboard/report': typeof DashboardReportLazyRoute
  '/dashboard/settings': typeof DashboardSettingsLazyRouteWithChildren
  '/dashboard/sponsors': typeof DashboardSponsorsLazyRoute
  '/docs/api': typeof DocsApiLazyRoute
  '/profile/$username': typeof ProfileUsernameLazyRoute
  '/tournament/$id': typeof TournamentIdLazyRoute
  '/dashboard/': typeof DashboardIndexLazyRoute
  '/dashboard/activations/edit': typeof DashboardActivationsEditLazyRoute
  '/dashboard/broadcast/preflight': typeof DashboardBroadcastPreflightLazyRoute
  '/dashboard/settings/data': typeof DashboardSettingsDataLazyRoute
  '/dashboard/settings/integrations': typeof DashboardSettingsIntegrationsLazyRoute
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsLazyRoute
  '/dashboard/tournaments/live': typeof DashboardTournamentsLiveLazyRoute
  '/dashboard/tournaments/rules': typeof DashboardTournamentsRulesLazyRoute
  '/dashboard/tournaments/seeding': typeof DashboardTournamentsSeedingLazyRoute
  '/dashboard/tournaments/templates': typeof DashboardTournamentsTemplatesLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/builder'
    | '/configurator'
    | '/dashboard'
    | '/notifications'
    | '/onboarding'
    | '/player'
    | '/sponsor'
    | '/$'
    | '/changelog'
    | '/community'
    | '/help'
    | '/leaderboard'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/verify-email'
    | '/admin/audit-log'
    | '/admin/disputes'
    | '/admin/roles'
    | '/admin/users'
    | '/dashboard/account'
    | '/dashboard/analytics'
    | '/dashboard/announcements'
    | '/dashboard/archive'
    | '/dashboard/billing'
    | '/dashboard/branding'
    | '/dashboard/empty-states'
    | '/dashboard/influencers'
    | '/dashboard/media'
    | '/dashboard/messages'
    | '/dashboard/notifications'
    | '/dashboard/referral'
    | '/dashboard/report'
    | '/dashboard/settings'
    | '/dashboard/sponsors'
    | '/docs/api'
    | '/profile/$username'
    | '/tournament/$id'
    | '/dashboard/'
    | '/dashboard/activations/edit'
    | '/dashboard/broadcast/preflight'
    | '/dashboard/settings/data'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/notifications'
    | '/dashboard/tournaments/live'
    | '/dashboard/tournaments/rules'
    | '/dashboard/tournaments/seeding'
    | '/dashboard/tournaments/templates'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/builder'
    | '/configurator'
    | '/notifications'
    | '/onboarding'
    | '/player'
    | '/sponsor'
    | '/$'
    | '/changelog'
    | '/community'
    | '/help'
    | '/leaderboard'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/verify-email'
    | '/admin/audit-log'
    | '/admin/disputes'
    | '/admin/roles'
    | '/admin/users'
    | '/dashboard/account'
    | '/dashboard/analytics'
    | '/dashboard/announcements'
    | '/dashboard/archive'
    | '/dashboard/billing'
    | '/dashboard/branding'
    | '/dashboard/empty-states'
    | '/dashboard/influencers'
    | '/dashboard/media'
    | '/dashboard/messages'
    | '/dashboard/notifications'
    | '/dashboard/referral'
    | '/dashboard/report'
    | '/dashboard/settings'
    | '/dashboard/sponsors'
    | '/docs/api'
    | '/profile/$username'
    | '/tournament/$id'
    | '/dashboard'
    | '/dashboard/activations/edit'
    | '/dashboard/broadcast/preflight'
    | '/dashboard/settings/data'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/notifications'
    | '/dashboard/tournaments/live'
    | '/dashboard/tournaments/rules'
    | '/dashboard/tournaments/seeding'
    | '/dashboard/tournaments/templates'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/builder'
    | '/configurator'
    | '/dashboard'
    | '/notifications'
    | '/onboarding'
    | '/player'
    | '/sponsor'
    | '/$'
    | '/changelog'
    | '/community'
    | '/help'
    | '/leaderboard'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/verify-email'
    | '/admin/audit-log'
    | '/admin/disputes'
    | '/admin/roles'
    | '/admin/users'
    | '/dashboard/account'
    | '/dashboard/analytics'
    | '/dashboard/announcements'
    | '/dashboard/archive'
    | '/dashboard/billing'
    | '/dashboard/branding'
    | '/dashboard/empty-states'
    | '/dashboard/influencers'
    | '/dashboard/media'
    | '/dashboard/messages'
    | '/dashboard/notifications'
    | '/dashboard/referral'
    | '/dashboard/report'
    | '/dashboard/settings'
    | '/dashboard/sponsors'
    | '/docs/api'
    | '/profile/$username'
    | '/tournament/$id'
    | '/dashboard/'
    | '/dashboard/activations/edit'
    | '/dashboard/broadcast/preflight'
    | '/dashboard/settings/data'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/notifications'
    | '/dashboard/tournaments/live'
    | '/dashboard/tournaments/rules'
    | '/dashboard/tournaments/seeding'
    | '/dashboard/tournaments/templates'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AdminRoute: typeof AdminRouteWithChildren
  BuilderRoute: typeof BuilderRoute
  ConfiguratorRoute: typeof ConfiguratorRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  PlayerRoute: typeof PlayerRoute
  SponsorRoute: typeof SponsorRoute
  SplatLazyRoute: typeof SplatLazyRoute
  ChangelogLazyRoute: typeof ChangelogLazyRoute
  CommunityLazyRoute: typeof CommunityLazyRoute
  HelpLazyRoute: typeof HelpLazyRoute
  LeaderboardLazyRoute: typeof LeaderboardLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  ProfileLazyRoute: typeof ProfileLazyRouteWithChildren
  RegisterLazyRoute: typeof RegisterLazyRoute
  ResetPasswordLazyRoute: typeof ResetPasswordLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  VerifyEmailLazyRoute: typeof VerifyEmailLazyRoute
  DocsApiLazyRoute: typeof DocsApiLazyRoute
  TournamentIdLazyRoute: typeof TournamentIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsor': {
      id: '/sponsor'
      path: '/sponsor'
      fullPath: '/sponsor'
      preLoaderRoute: typeof SponsorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player': {
      id: '/player'
      path: '/player'
      fullPath: '/player'
      preLoaderRoute: typeof PlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configurator': {
      id: '/configurator'
      path: '/configurator'
      fullPath: '/configurator'
      preLoaderRoute: typeof ConfiguratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder': {
      id: '/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof BuilderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/tournament/$id': {
      id: '/tournament/$id'
      path: '/tournament/$id'
      fullPath: '/tournament/$id'
      preLoaderRoute: typeof TournamentIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$username': {
      id: '/profile/$username'
      path: '/$username'
      fullPath: '/profile/$username'
      preLoaderRoute: typeof ProfileUsernameLazyRouteImport
      parentRoute: typeof ProfileLazyRoute
    }
    '/docs/api': {
      id: '/docs/api'
      path: '/docs/api'
      fullPath: '/docs/api'
      preLoaderRoute: typeof DocsApiLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/sponsors': {
      id: '/dashboard/sponsors'
      path: '/sponsors'
      fullPath: '/dashboard/sponsors'
      preLoaderRoute: typeof DashboardSponsorsLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/report': {
      id: '/dashboard/report'
      path: '/report'
      fullPath: '/dashboard/report'
      preLoaderRoute: typeof DashboardReportLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/referral': {
      id: '/dashboard/referral'
      path: '/referral'
      fullPath: '/dashboard/referral'
      preLoaderRoute: typeof DashboardReferralLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notifications': {
      id: '/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof DashboardNotificationsLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/messages': {
      id: '/dashboard/messages'
      path: '/messages'
      fullPath: '/dashboard/messages'
      preLoaderRoute: typeof DashboardMessagesLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/media': {
      id: '/dashboard/media'
      path: '/media'
      fullPath: '/dashboard/media'
      preLoaderRoute: typeof DashboardMediaLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/influencers': {
      id: '/dashboard/influencers'
      path: '/influencers'
      fullPath: '/dashboard/influencers'
      preLoaderRoute: typeof DashboardInfluencersLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/empty-states': {
      id: '/dashboard/empty-states'
      path: '/empty-states'
      fullPath: '/dashboard/empty-states'
      preLoaderRoute: typeof DashboardEmptyStatesLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/branding': {
      id: '/dashboard/branding'
      path: '/branding'
      fullPath: '/dashboard/branding'
      preLoaderRoute: typeof DashboardBrandingLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing': {
      id: '/dashboard/billing'
      path: '/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof DashboardBillingLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/archive': {
      id: '/dashboard/archive'
      path: '/archive'
      fullPath: '/dashboard/archive'
      preLoaderRoute: typeof DashboardArchiveLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/announcements': {
      id: '/dashboard/announcements'
      path: '/announcements'
      fullPath: '/dashboard/announcements'
      preLoaderRoute: typeof DashboardAnnouncementsLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics': {
      id: '/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/account': {
      id: '/dashboard/account'
      path: '/account'
      fullPath: '/dashboard/account'
      preLoaderRoute: typeof DashboardAccountLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersLazyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesLazyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/disputes': {
      id: '/admin/disputes'
      path: '/disputes'
      fullPath: '/admin/disputes'
      preLoaderRoute: typeof AdminDisputesLazyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogLazyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard/tournaments/templates': {
      id: '/dashboard/tournaments/templates'
      path: '/tournaments/templates'
      fullPath: '/dashboard/tournaments/templates'
      preLoaderRoute: typeof DashboardTournamentsTemplatesLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tournaments/seeding': {
      id: '/dashboard/tournaments/seeding'
      path: '/tournaments/seeding'
      fullPath: '/dashboard/tournaments/seeding'
      preLoaderRoute: typeof DashboardTournamentsSeedingLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tournaments/rules': {
      id: '/dashboard/tournaments/rules'
      path: '/tournaments/rules'
      fullPath: '/dashboard/tournaments/rules'
      preLoaderRoute: typeof DashboardTournamentsRulesLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tournaments/live': {
      id: '/dashboard/tournaments/live'
      path: '/tournaments/live'
      fullPath: '/dashboard/tournaments/live'
      preLoaderRoute: typeof DashboardTournamentsLiveLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/notifications': {
      id: '/dashboard/settings/notifications'
      path: '/notifications'
      fullPath: '/dashboard/settings/notifications'
      preLoaderRoute: typeof DashboardSettingsNotificationsLazyRouteImport
      parentRoute: typeof DashboardSettingsLazyRoute
    }
    '/dashboard/settings/integrations': {
      id: '/dashboard/settings/integrations'
      path: '/integrations'
      fullPath: '/dashboard/settings/integrations'
      preLoaderRoute: typeof DashboardSettingsIntegrationsLazyRouteImport
      parentRoute: typeof DashboardSettingsLazyRoute
    }
    '/dashboard/settings/data': {
      id: '/dashboard/settings/data'
      path: '/data'
      fullPath: '/dashboard/settings/data'
      preLoaderRoute: typeof DashboardSettingsDataLazyRouteImport
      parentRoute: typeof DashboardSettingsLazyRoute
    }
    '/dashboard/broadcast/preflight': {
      id: '/dashboard/broadcast/preflight'
      path: '/broadcast/preflight'
      fullPath: '/dashboard/broadcast/preflight'
      preLoaderRoute: typeof DashboardBroadcastPreflightLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/activations/edit': {
      id: '/dashboard/activations/edit'
      path: '/activations/edit'
      fullPath: '/dashboard/activations/edit'
      preLoaderRoute: typeof DashboardActivationsEditLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAuditLogLazyRoute: typeof AdminAuditLogLazyRoute
  AdminDisputesLazyRoute: typeof AdminDisputesLazyRoute
  AdminRolesLazyRoute: typeof AdminRolesLazyRoute
  AdminUsersLazyRoute: typeof AdminUsersLazyRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditLogLazyRoute: AdminAuditLogLazyRoute,
  AdminDisputesLazyRoute: AdminDisputesLazyRoute,
  AdminRolesLazyRoute: AdminRolesLazyRoute,
  AdminUsersLazyRoute: AdminUsersLazyRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DashboardSettingsLazyRouteChildren {
  DashboardSettingsDataLazyRoute: typeof DashboardSettingsDataLazyRoute
  DashboardSettingsIntegrationsLazyRoute: typeof DashboardSettingsIntegrationsLazyRoute
  DashboardSettingsNotificationsLazyRoute: typeof DashboardSettingsNotificationsLazyRoute
}

const DashboardSettingsLazyRouteChildren: DashboardSettingsLazyRouteChildren = {
  DashboardSettingsDataLazyRoute: DashboardSettingsDataLazyRoute,
  DashboardSettingsIntegrationsLazyRoute:
    DashboardSettingsIntegrationsLazyRoute,
  DashboardSettingsNotificationsLazyRoute:
    DashboardSettingsNotificationsLazyRoute,
}

const DashboardSettingsLazyRouteWithChildren =
  DashboardSettingsLazyRoute._addFileChildren(
    DashboardSettingsLazyRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardAccountLazyRoute: typeof DashboardAccountLazyRoute
  DashboardAnalyticsLazyRoute: typeof DashboardAnalyticsLazyRoute
  DashboardAnnouncementsLazyRoute: typeof DashboardAnnouncementsLazyRoute
  DashboardArchiveLazyRoute: typeof DashboardArchiveLazyRoute
  DashboardBillingLazyRoute: typeof DashboardBillingLazyRoute
  DashboardBrandingLazyRoute: typeof DashboardBrandingLazyRoute
  DashboardEmptyStatesLazyRoute: typeof DashboardEmptyStatesLazyRoute
  DashboardInfluencersLazyRoute: typeof DashboardInfluencersLazyRoute
  DashboardMediaLazyRoute: typeof DashboardMediaLazyRoute
  DashboardMessagesLazyRoute: typeof DashboardMessagesLazyRoute
  DashboardNotificationsLazyRoute: typeof DashboardNotificationsLazyRoute
  DashboardReferralLazyRoute: typeof DashboardReferralLazyRoute
  DashboardReportLazyRoute: typeof DashboardReportLazyRoute
  DashboardSettingsLazyRoute: typeof DashboardSettingsLazyRouteWithChildren
  DashboardSponsorsLazyRoute: typeof DashboardSponsorsLazyRoute
  DashboardIndexLazyRoute: typeof DashboardIndexLazyRoute
  DashboardActivationsEditLazyRoute: typeof DashboardActivationsEditLazyRoute
  DashboardBroadcastPreflightLazyRoute: typeof DashboardBroadcastPreflightLazyRoute
  DashboardTournamentsLiveLazyRoute: typeof DashboardTournamentsLiveLazyRoute
  DashboardTournamentsRulesLazyRoute: typeof DashboardTournamentsRulesLazyRoute
  DashboardTournamentsSeedingLazyRoute: typeof DashboardTournamentsSeedingLazyRoute
  DashboardTournamentsTemplatesLazyRoute: typeof DashboardTournamentsTemplatesLazyRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAccountLazyRoute: DashboardAccountLazyRoute,
  DashboardAnalyticsLazyRoute: DashboardAnalyticsLazyRoute,
  DashboardAnnouncementsLazyRoute: DashboardAnnouncementsLazyRoute,
  DashboardArchiveLazyRoute: DashboardArchiveLazyRoute,
  DashboardBillingLazyRoute: DashboardBillingLazyRoute,
  DashboardBrandingLazyRoute: DashboardBrandingLazyRoute,
  DashboardEmptyStatesLazyRoute: DashboardEmptyStatesLazyRoute,
  DashboardInfluencersLazyRoute: DashboardInfluencersLazyRoute,
  DashboardMediaLazyRoute: DashboardMediaLazyRoute,
  DashboardMessagesLazyRoute: DashboardMessagesLazyRoute,
  DashboardNotificationsLazyRoute: DashboardNotificationsLazyRoute,
  DashboardReferralLazyRoute: DashboardReferralLazyRoute,
  DashboardReportLazyRoute: DashboardReportLazyRoute,
  DashboardSettingsLazyRoute: DashboardSettingsLazyRouteWithChildren,
  DashboardSponsorsLazyRoute: DashboardSponsorsLazyRoute,
  DashboardIndexLazyRoute: DashboardIndexLazyRoute,
  DashboardActivationsEditLazyRoute: DashboardActivationsEditLazyRoute,
  DashboardBroadcastPreflightLazyRoute: DashboardBroadcastPreflightLazyRoute,
  DashboardTournamentsLiveLazyRoute: DashboardTournamentsLiveLazyRoute,
  DashboardTournamentsRulesLazyRoute: DashboardTournamentsRulesLazyRoute,
  DashboardTournamentsSeedingLazyRoute: DashboardTournamentsSeedingLazyRoute,
  DashboardTournamentsTemplatesLazyRoute:
    DashboardTournamentsTemplatesLazyRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface ProfileLazyRouteChildren {
  ProfileUsernameLazyRoute: typeof ProfileUsernameLazyRoute
}

const ProfileLazyRouteChildren: ProfileLazyRouteChildren = {
  ProfileUsernameLazyRoute: ProfileUsernameLazyRoute,
}

const ProfileLazyRouteWithChildren = ProfileLazyRoute._addFileChildren(
  ProfileLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AdminRoute: AdminRouteWithChildren,
  BuilderRoute: BuilderRoute,
  ConfiguratorRoute: ConfiguratorRoute,
  DashboardRoute: DashboardRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  PlayerRoute: PlayerRoute,
  SponsorRoute: SponsorRoute,
  SplatLazyRoute: SplatLazyRoute,
  ChangelogLazyRoute: ChangelogLazyRoute,
  CommunityLazyRoute: CommunityLazyRoute,
  HelpLazyRoute: HelpLazyRoute,
  LeaderboardLazyRoute: LeaderboardLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  ProfileLazyRoute: ProfileLazyRouteWithChildren,
  RegisterLazyRoute: RegisterLazyRoute,
  ResetPasswordLazyRoute: ResetPasswordLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  VerifyEmailLazyRoute: VerifyEmailLazyRoute,
  DocsApiLazyRoute: DocsApiLazyRoute,
  TournamentIdLazyRoute: TournamentIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
